<template>
  <div class="sc-card no-shadow" style="margin: 0 auto; max-width: 610px;">
    <div class="sc-card-body" style="margin-bottom: 170px;">
      <h4 class="sc-card-title text-center">Transferir para o banco</h4>
      <h6
        class="text-center text-size-4 text-height-4 text-weight-light mb-3"
        :style="useStyles.colorDarkGray"
      >
        Escolha, ou adicione, uma conta e realize a transferência do seu saldo
        disponível. A transação será finalizada em até 3 dias úteis.
      </h6>

      <form style="margin-top: 130px;">
        <div class="currency-form-control">
          <label>Quanto quer transferir?</label>
          <input
            type="number"
            name="currencyField"
            v-model="amount"
            min="10"
            placeholder="R$ 0,00"
          />
        </div>

        <div class="mt-5 full-width text-center">
          <span
            class="text-size-4 text-weight-medium font-public-sans"
            :style="useStyles.colorDarkGray"
          >
            Saldo disponível:
            <b class="text-weight-bold" :style="useStyles.colorDark">
              {{ $store.getters["doctor/balancesFormated"].available }}
            </b>
            <br />
            Saque mínimo:
            <b class="text-weight-bold" :style="useStyles.colorDark">
              R$ 10
            </b>
          </span>
        </div>
      </form>
    </div>

    <div class="sc-card-divider" />

    <div class="sc-body d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <span
          class="sc-badge sc-badge-lg sc-badge-card mr-2"
          style="border-radius: 12px;"
        >
          <Icon
            name="dollar-sign-icon"
            :height="24"
            :width="24"
            style="stroke:#495057;"
          />
        </span>
        <div>
          <h6 class="text-size-4 text-weight-medium" style="color#343A40;">
            {{ bankAccount.bank_name }}
          </h6>
          <span
            class="text-size-3 text-weight-medium"
            :style="useStyles.colorGray"
          >
            Conta corrente {{ bankAccount.account_number }}
          </span>
        </div>
      </div>
    </div>

    <div class="sc-card-divider" />

    <div class="mt-4 mb-4" @click.prevent="transfer()">
      <Button variant="primary" block size="lg" :disabled="!canTransfer">
        Solicitar transferência
      </Button>
    </div>
  </div>
</template>

<script>
import Button from "./Button";
import Icon from "./CustomIcons.vue";
import Swal from "sweetalert2";

export default {
  name: "TransferBalanceForm",
  components: {
    Button,
    Icon
  },
  data() {
    return {
      amount: ""
    };
  },
  methods: {
    transfer() {
      Swal.fire({
        title: "Confirmar retirada de saldo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#49838a",
        cancelButtonColor: "#cb6262",
        confirmButtonText: "Sim, confirmar!",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const amount = this.amount * 100;
          return this.$store
            .dispatch("doctor/bankTransfer", { amount })
            .then(() => {
              Swal.fire(
                "Sucesso!",
                "Sua conta foi deletada com sucesso.",
                "success"
              );
              this.$bvModal.hide("bankTransfer");
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Erro ao processar a transação",
                text: "Tente novamente mais tarde!"
              });
            });
        }
      });
    }
  },
  computed: {
    bankAccount() {
      return this.$store.state.doctor.bank_account;
    },
    useStyles() {
      return {
        colorDark: {
          color: "#495057"
        },
        colorDarkGray: {
          color: "#868E96"
        },
        colorGray: {
          color: "#adb5bd"
        }
      };
    },
    c1anTransfer() {
      return this.$store.getters["doctor/balances"].available;
    },
    canTransfer() {
      return (
        this.amount >= 10 &&
        this.amount <= this.$store.getters["doctor/balances"].available / 100
      );
    }
  }
};
</script>
